import { Col, TimePicker, TimeRangePickerProps } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledTimePickerRange = styled(TimePicker.RangePicker)`
  width: 100% !important;
  padding: 0;
  .ant-picker-input {
    border-bottom: 1px solid var(--color-gray-103);
    input {
      padding: 4px 0;
    }
  }
  .ant-picker-input::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-image: url('images/ic-clock.svg');
    background-size: 20px 20px;
    background-repeat: no-repeat;
  }
  .ant-picker-range-separator {
    display: none;
  }
  .ant-picker-active-bar {
    background: var(--color-primary-108);
  }
  .ant-picker-active-bar {
    display: none;
  }
  .ant-picker-suffix {
    display: none;
  }
  .ant-picker-input:nth-child(1) {
    margin-right: 8px;
  }
  .ant-picker-input:nth-child(3) {
    margin-left: 8px;
  }
  .ant-picker-input-active {
    border-color: var(--color-primary-108);
  }
  .ant-picker-clear {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: start;
    right: 0;
  }
  &.prevent-input {
    pointer-events: none;
    .ant-picker-input-active {
      border-color: var(--color-gray-103);
    }
  }
`
const StyledTitle = styled.div`
  display: flex;
  div {
    flex: 1;
    color: var(--color-gray-111);
    font-weight: 600;
    font-size: 1.4rem;
    span {
      color: var(--color-red-107);
    }
  }
  .title-to {
    margin-left: 8px;
  }
`
const StyledTitleMain = styled.div`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
`

interface IProps extends TimeRangePickerProps {
  title?: string
  required?: boolean
  preventInput?: boolean
  classNameContainer?: string
}

const TimePickerRange = (props: IProps) => {
  const {
    style = { width: 180 },
    required,
    preventInput,
    classNameContainer,
    title,
    ...resProps
  } = props
  const { t } = useTranslation()
  return (
    <Col className={classNameContainer}>
      {!!title && <StyledTitleMain>{t(title || '')}</StyledTitleMain>}
      <StyledTitle>
        <div>
          {t('from-time')}
          {required && <span> *</span>}
        </div>
        <div className="title-to">
          {t('to-time')}
          {required && <span> *</span>}
        </div>
      </StyledTitle>
      <StyledTimePickerRange
        style={style}
        className={preventInput ? 'prevent-input' : ''}
        bordered={false}
        placeholder={['HH:mm', 'HH:mm']}
        suffixIcon={<img src="images/ic-clock.svg" alt="" />}
        {...resProps}
      />
    </Col>
  )
}

export default TimePickerRange
